import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ICountryCodesPhoneNumber } from '../entities/tel-input.model';
import { APP_CONFIG } from '@application/config';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TelInputService {
  private http = inject(HttpClient);
  private apiUrl = inject(APP_CONFIG).apiUrl;

  public getCountryCodesPhoneNumber(language: string): Observable<ICountryCodesPhoneNumber[]> {
    return this.http.get<ICountryCodesPhoneNumber[]>(this.apiUrl.account_service + `/SettingsOptions/GetCountryCodesPhoneNumber`, {
      params: {
        language
      },
      withCredentials: true
    })
  }
}
